module.exports = __webpack_public_path__ + "static/media/hospital3.efb62390.jpg";